import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom'; // Import Link for navigation
import SEO from '../../common/SEO';
import HeaderOne from '../../common/header/HeaderOne';
import HeaderTopBar from '../../common/header/HeaderTopBar';
import FooterOne from '../../common/footer/FooterOne';
import Copyright from '../../common/footer/Copyright';


const Thanks = () => {
    const [countdown, setCountdown] = useState(15);

    useEffect(() => {
        if (countdown > 0) {
            const timer = setTimeout(() => {
                setCountdown(countdown - 1);
            }, 1000);
            return () => clearTimeout(timer); // Clear timeout on unmount or when countdown changes
        } else {
            // Redirect to homepage after countdown reaches 0
            window.location.href = "/"; // Use window.location.href for redirect
        }
    }, [countdown]);

    return (
        <>
            <SEO title="Thank You" />
            <main className="page-wrapper">
                <HeaderTopBar />
                <HeaderOne btnStyle="btn-small" HeaderSTyle="header-transparent" />

                <div className="rwt-advance-tab-area rn-section-gap d-flex justify-content-center align-items-center" style={{ minHeight: '60vh' }}>
                    <div className="w-100 text-center">
                        <div className="container mt-5">
                            <h1 className="display-4 mb-4">Thank you for submitting your info!</h1>
                            <div className="mt-4">
                                <Link to="/">
                                    <button className='btn-default'>
                                        Go to Homepage
                                    </button>
                                </Link>
                            </div>
                            {countdown > 0 && (
                                <p className="mt-5">
                                    Redirecting to homepage in {countdown} seconds...
                                </p>
                            )}
                        </div>
                    </div>
                </div>

                <FooterOne />
                <Copyright />
            </main>
        </>
    );
};

export default Thanks;
